import React from 'react';
import { CloseIcon } from './icons';

const AlertModal = ({ isOpen, onClose, title, message, onConfirm }) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-dark-surface border border-dark-border rounded-lg w-full max-w-md max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-dark-border">
          <h3 className="text-lg font-semibold text-dark-text-primary">{title}</h3>
          <button 
            onClick={onClose}
            className="p-1 rounded-md text-dark-text-secondary hover:bg-dark-bg"
          >
            <CloseIcon className="w-5 h-5" />
          </button>
        </div>
        
        <div className="p-4 overflow-y-auto flex-grow">
          <p className="text-dark-text-primary">{message}</p>
        </div>
        
        <div className="p-4 border-t border-dark-border">
          <div className="flex gap-2">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 bg-dark-bg border border-dark-border text-dark-text-primary rounded-md hover:bg-dark-surface transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              className="flex-1 px-4 py-2 bg-brand-primary text-white rounded-md hover:bg-brand-primary/90 transition-colors"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;